{
	"imprintTitle": "Note legali",
	"termsAndConditionsTitle": "Termini e condizioni",
	"privacyPolicyTitle": "Informativa sulla privacy",
	"openSourceAttributionTitle": "Attribuzione open source"
}
